import { Button, Container, Flex, Heading, Text } from "@radix-ui/themes"
import React, { useCallback, useEffect, useState } from "react"
import PasswordInput from "../../components/controls/inputs/PasswordInput"
import { toast, ToastContainer } from "react-toastify"
import {useNavigate, useParams} from 'react-router'
import useFetch from "../../core/hooks/useFetch"
import UserService from "../../core/services/UserService"
import {ROUTES} from '../../routes/constants'
export default function ResetPasswordFinish() {
    const {id} = useParams()
    const [password, setPassword] = useState<string>('')
    const [retryPassword, setRetryPassword] = useState<string>('')
    const navigate = useNavigate()
    const redirect = useCallback(() => {
        navigate(ROUTES.ACCOUNT_ROUTE)
    }, [navigate])
    const [fetchResetPassword, isLoading, error, errors] = useFetch(async () => {
        if(id) {
        const data = await UserService.ResetPasswordFinal({password, retryPassword, uniq_id: id})
        toast.success("Пароль успешно изменен!")
        redirect()
        }
    })
    useEffect(() => {
       if(error.length) toast.error(error)
    }, [error])
    return (
        <Container className="p-5">
                 <ToastContainer />
               <Container className="heading-reset-password">
                    <Heading>
                        Восстановление пароля
                    </Heading>
                </Container>
        <Flex justify={'center'} direction={'column'} gap={'3'} className="pt-5">
            <Flex gap={'3'} direction={'column'}>
                <Text>Новый Пароль (Минимальная длина пароля составляет 6 символов, и, как минимум должен содержать одну заглавную букву и цифры)</Text>
                <PasswordInput value={password} onChange={e => setPassword(e.target.value)} />
                <Text>Повторите новый пароль</Text>
                <PasswordInput value={retryPassword} onChange={e => setRetryPassword(e.target.value)} />
            </Flex>
            <Button loading={isLoading} onClick={async () => fetchResetPassword()}>
                Изменить пароль
            </Button>
        </Flex>
    </Container>
    )
}